var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 13.2943L118.706 0L66 52.7057L13.2943 0L0 13.2943L52.7057 66L0 118.706L13.2943 132L66 79.2943L118.706 132L132 118.706L79.2943 66L132 13.2943Z",
    fill: "var(--klothed-bgColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9407 66.3536L131.293 118.706L118.706 131.293L66.3536 78.9407L66 78.5872L65.6464 78.9407L13.2943 131.293L0.707107 118.706L53.0593 66.3536L53.4128 66L53.0593 65.6465L0.707107 13.2943L13.2943 0.707107L65.6464 53.0593L66 53.4128L66.3536 53.0593L118.706 0.707107L131.293 13.2943L78.9407 65.6465L78.5872 66L78.9407 66.3536Z",
    stroke: "var(--klothed-textColor)",
    strokeOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNot);
export default __webpack_public_path__ + "static/media/icon-not.a012c7fefecafb6fe48b8c30a41f2a24.svg";
export { ForwardRef as ReactComponent };